import { ReactNode, MouseEvent } from 'react';
import { StyledIconButton } from '../Button';
import { SearchIcon } from '../Icon';
import {
	StyledSearchInputButtonWrap,
	IStyledSearchInputButtonWrapProps,
} from './StyledSearchInputButtonWrap';

interface ISearchInputButtonWrapProps
	extends IStyledSearchInputButtonWrapProps {
	children: ReactNode;
	onClickSearch: (e: MouseEvent) => void;
	disabled?: boolean;
	ariaLabel?: string;
	className?: string;
}

export function SearchInputButtonWrap({
	children,
	onClickSearch,
	disabled,
	ariaLabel,
	...rest
}: ISearchInputButtonWrapProps) {
	return (
		<StyledSearchInputButtonWrap disabled={disabled} {...rest}>
			{children}
			<StyledIconButton
				disabled={disabled}
				onClick={onClickSearch}
				aria-label={ariaLabel ?? 'Search'}
			>
				<SearchIcon variation="inverted" />
			</StyledIconButton>
		</StyledSearchInputButtonWrap>
	);
}
